import { CheckOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Revela } from '../components/Revela';

export function Metodo() {
  return (
    <section id="metodo" className="metodo-secao">
      <div className="landing-secao metodo-grade">
        <Revela>
          <div className="secao-abertura">
            <span className="sobretitulo">COMENTÁRIOS PARA REVISAR O CONTEÚDO</span>
            <h2>
              Não pare no gabarito.
              <br />
              <em>Leia o fundamento.</em>
            </h2>
            <p>
              Consulte os dispositivos citados e acompanhe a explicação de cada alternativa, com
              legislação, jurisprudência e doutrina reunidas na questão.
            </p>
            <a className="link-editorial" href="#demonstracao">
              Explore um comentário <ArrowRightOutlined />
            </a>
          </div>
        </Revela>
        <Revela>
          <div className="metodo-lista">
            <article>
              <span>01</span>
              <div>
                <h3>Referências conferidas</h3>
                <p>Citações de lei conferidas com o texto oficial, dispositivo por dispositivo.</p>
              </div>
              <CheckOutlined />
            </article>
            <article>
              <span>02</span>
              <div>
                <h3>Revisão antes da publicação</h3>
                <p>
                  Conteúdo revisado por profissionais qualificados antes de chegar ao seu estudo.
                </p>
              </div>
              <CheckOutlined />
            </article>
            <article>
              <span>03</span>
              <div>
                <h3>Conteúdo que pode evoluir</h3>
                <p>
                  Reporte inconsistências na própria questão. As correções preservam o histórico e a
                  versão que você respondeu.
                </p>
              </div>
              <CheckOutlined />
            </article>
            <div className="metodo-assinatura">Experimente os comentários da questão 1 acima.</div>
          </div>
        </Revela>
      </div>
    </section>
  );
}
